module.exports = __webpack_public_path__ + "assets/img/userContent.e8210205.png";